import React from 'react';

const InvoiceModal = ({ invoice, onClose }) => {
  if (!invoice) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '80%',
        maxHeight: '80%',
        overflowY: 'auto',
        position: 'relative'
      }}>
        <button onClick={onClose} style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          fontSize: '16px',
          cursor: 'pointer'
        }}>Close</button>
        <h2>Invoice Details - {invoice.invoice_no}</h2>
        <div>
          <p><strong>Type:</strong> {invoice.invoice_type}</p>
          <p><strong>Date:</strong> {new Date(invoice.invoice_date).toLocaleDateString()}</p>
          <p><strong>Name:</strong> {invoice.name}</p>
          <p><strong>Taxable Amount:</strong> {invoice.Taxable_amt}</p>
          <p><strong>Total Amount:</strong> {invoice.Total_amt}</p>
          <p><strong>Paid Amount:</strong> {invoice.Paid_Amt}</p>
          <p><strong>Supplier:</strong> {invoice.supplier_name}</p>
          <p><strong>GST No:</strong> {invoice.GST_no}</p>
          <p><strong>Contact Info:</strong> {invoice.email} / {invoice.phone_no}</p>
          <p><strong>Comments:</strong> {invoice.Comments}</p>

          {/* Add more invoice details as needed */}
        </div>
      </div>
    </div>
  );
};

export default InvoiceModal;
